import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

//import { preconnectWebSocket } from './NewWebSocket/context/WebSocketContext';

// Preconnect to WebSocket before rendering React
// This establishes the connection earlier, reducing perceived loading time
/* preconnectWebSocket('ws://localhost:8082/ws');
// Also try the IP address variant as a fallback
setTimeout(() => preconnectWebSocket('ws://127.0.0.1:8082/ws'), 100); */

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
   //React.StrictMode>
        <App />
   ///React.StrictMode>
  );
}

reportWebVitals();
